import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ApplianceService from "./pages/ApplianceService";
import ServiceCharges from "./pages/ServiceCharges";
import ServiceAreas from "./pages/ServiceAreas";
import BookService from "./pages/BookService";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQPage from "./pages/FAQPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chimney-service" element={<ApplianceService slug="chimney" />} />
          <Route path="/hob-service" element={<ApplianceService slug="hob" />} />
          <Route path="/cooktop-service" element={<ApplianceService slug="cooktop" />} />
          <Route path="/oven-service" element={<ApplianceService slug="oven" />} />
          <Route path="/microwave-oven-service" element={<ApplianceService slug="microwave" />} />
          <Route path="/dishwasher-service" element={<ApplianceService slug="dishwasher" />} />
          <Route path="/service-charges" element={<ServiceCharges />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/book-service" element={<BookService />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
